import { Button, Form, Input } from 'antd';
import { UserOutlined, MailOutlined } from '@ant-design/icons';

interface IEmailFormProps {
  username: string;
  email: string;
  loading: boolean;
  onUsernameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onSubmit: () => void;
  onBack: () => void;
}

export const EmailForm = ({
  username,
  email,
  loading,
  onUsernameChange,
  onEmailChange,
  onSubmit,
  onBack,
}: IEmailFormProps) => {
  const [form] = Form.useForm();

  const handleFinish = () => {
    onSubmit();
  };

  return (
    <div className='w-full'>
      <div className='mb-6 text-center'>
        <p className='text-gray-600 text-sm'>
          Vui lòng nhập thông tin để nhận mã cài đặt lại mật khẩu qua email
        </p>
      </div>

      <Form form={form} layout='vertical' onFinish={handleFinish}>
        <Form.Item
          label='Tên đăng nhập'
          name='username'
          initialValue={username}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập tên đăng nhập',
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className='text-gray-400' />}
            placeholder='Nhập tên đăng nhập'
            size='large'
            value={username}
            onChange={(e) => onUsernameChange(e.target.value)}
          />
        </Form.Item>

        <Form.Item
          label='Email'
          name='email'
          initialValue={email}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập email',
            },
            {
              type: 'email',
              message: 'Email không đúng định dạng',
            },
          ]}
        >
          <Input
            prefix={<MailOutlined className='text-gray-400' />}
            placeholder='example@email.com'
            size='large'
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </Form.Item>

        <Form.Item className='mb-4'>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            loading={loading}
            className='w-full bg-[#1677ff]'
          >
            Tiếp tục
          </Button>
        </Form.Item>

        <Form.Item className='mb-0'>
          <Button type='link' onClick={onBack} className='w-full text-gray-600'>
            Quay lại đăng nhập
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
